import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable, throwError } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { DIA_SEMANA, MES } from 'src/app/global/interfaces/agenda-literales';
import { AgendaResponse } from 'src/app/global/interfaces/agenda-response';
import { AgendaService } from 'src/app/global/services/agenda.service';
import { ValidacionEdicionService } from 'src/app/global/services/validacion-edicion.service';
import { AgendaServiceVM } from 'src/app/view-model/services/agenda-vm.service';


@Injectable()
export class AgendaProviderVM extends AgendaServiceVM {
    constructor(private agendaService: AgendaService,
                private valEdicionService: ValidacionEdicionService) {
        super();
    }

    formatFechas(fechas: any): any {
        const newFechas = _.map(fechas.value0, (fecha) => {
            const miFecha: Date = new Date(fecha + 'T00:00:00');
            const dia = miFecha.getDate();
            const mes = miFecha.getMonth();
            const anio = miFecha.getFullYear();
            const diaSemana = miFecha.getDay();
            return {
                fecha,
                dia,
                nombreDia: DIA_SEMANA[diaSemana],
                nombreMes: MES[mes],
                anio,
                default: fechas.value1 === fecha ? true : false
            };
        });
        return newFechas;
    }

    formatUnaFecha(fecha: any): any {
        const miFecha: Date = new Date(fecha + 'T00:00:00');
        const diaSemana = miFecha.getDay();
        const anio = miFecha.getFullYear();
        const mes = miFecha.getMonth();
        const dia = miFecha.getDate();
        return {
            fecha,
            dia,
            nombreDia: DIA_SEMANA[diaSemana],
            nombreMes: MES[mes],
            anio
        };
    }

    getAgenda(): Observable<AgendaResponse> {
        return this.agendaService.getAgenda()
            .pipe(map(this.getAgendaOK), catchError(this.serviceError));
    }

    getAgendaSinFormato(): Promise<any> {
        return this.agendaService.getAgenda()
            .pipe(map(this.getAgendaSinFormatoOK), catchError(this.serviceError)).toPromise();
    }

    private getAgendaSinFormatoOK(resp) {
        return resp;
    }

    private getAgendaOK(resp: any) {
        const fechas = _.map(resp.data.value0, (fecha) => {
            const miFecha: Date = new Date(fecha + 'T00:00:00');
            const dia = miFecha.getDate();
            const mes = miFecha.getMonth();
            const anio = miFecha.getFullYear();
            const diaSemana = miFecha.getDay();
            return {
                fecha,
                dia,
                nombreDia: DIA_SEMANA[diaSemana],
                nombreMes: MES[mes],
                anio,
                default: resp.data.value1 === fecha ? true : false
            };
        });
        return fechas;
    }

    postAgenda(agenda: any): Observable<any> {
        const fechaSleccionada = {
            fecha: agenda
        };

        const agendaOK = () => {
            return this.valEdicionService.getValidacionEdicion();
        };

        const cbEdP3 = response => {
            return response;
        };
        return this.agendaService.postAgenda(fechaSleccionada)
            .pipe(mergeMap(agendaOK))
            .pipe(map(cbEdP3))
            .pipe(catchError(this.serviceError));
    }

    private serviceError(error) {
        return throwError(error);
    }


}
